<template>
  <TableRegular
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    :line-numbers="lineNumbers"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
    class="s"
  >
    <template slot="table-row" slot-scope="props">
      <p v-if="props.column.field === 'transactionDate'" class="whitespace-nowrap">
        {{ props.row.transactionDate }}
      </p>
      <p v-else-if="props.column.field === 'description'" class="leading-4 w-60">
        {{ props.row.description }}
      </p>
      <template v-else-if="props.column.field === 'firstBalance'" class="leading-4 w-60">
        {{ props.row.firstBalance | currency }}
      </template>
      <template v-else-if="props.column.field === 'income'" class="leading-4 w-60">
        {{ props.row.income === 0 ? '' : $options.filters.currency(props.row.income) }}
      </template>
      <template v-else-if="props.column.field === 'expense'" class="leading-4 w-60">
        {{ props.row.expense === 0 ? '' : $options.filters.currency(props.row.expense) }}
      </template>
      <template v-else-if="props.column.field === 'lastBalance'" class="leading-4 w-60">
        {{ props.row.lastBalance | currency }}
      </template>
      <template v-else-if="props.column.field === 'loanId'">
        <router-link
          v-if="props.row.loanId"
          :to="{ name: 'LoanDetails', params: { loanId: props.row.loanId } }"
          class="flex items-center"
        >
          <strong>{{ props.row.loanId }}</strong>
          <ArrowRightIcon class="w-4 h-4 ml-1" />
        </router-link>
        <div v-else @click="$emit('click', props.row.id)" class="flex items-center cursor-pointer">
          <ToolIcon class="w-4 h-4" />
        </div>
      </template>
      <div v-else-if="props.column.field === 'status'" class="whitespace-nowrap text-left">
        <CustomerTransactionDetailsPopover
          v-if="props.row.generalJournals && props.row.generalJournals.length > 0"
          :transaction-status="props.row.status"
          :transaction-id="props.row.id"
          :transactions="props.row.generalJournals"
          :another-key="props.row.id"
        />
        <div v-else :class="['status', `is-${statusToClassName(props.row.status)}`]">
          {{ $t(`status.${getStatus(props.row.status)}`) }}
        </div>
      </div>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';
import CustomerTransactionDetailsPopover from '@/components/generalJournal/CustomerTransactionDetailsPopover';

export default {
  mixins: [tableMixin],
  methods: {
    statusToClassName(status) {
      return status ? status.replace('_', '-').toLowerCase() : '';
    },
    getStatus(status) {
      return status ? humps.camelize(status.toLowerCase()) : '';
    },
  },
  components: {
    TableRegular,
    CustomerTransactionDetailsPopover,
  },
};
</script>
